/**
 * Section — картан хэлбэрийн бүлэг.
 *
 * Дашбоардын бүх блок ижил хүрээ, ижил дотор зайтай байх ёстой.
 * Өмнө нь блок бүр `rounded-card border border-hair bg-panel px-card`
 * гэж давтагдаж, нэг нь `py-4`, нөгөө нь `pt-4 pb-3.5` байсан тул
 * босоо хэмнэл алдагдсан байв.
 */

import type { ReactNode } from 'react';

export function Section({
  title,
  subtitle,
  note,
  actions,
  children,
  className = '',
  feature = false,
  badge,
}: {
  title: string;
  /** Гарчгийн хажуугийн тайлбар — жижиг, хоёрдогч */
  subtitle?: string;
  /** Анхаарах зүйл — жижиг, гуравдагч өнгө */
  note?: string;
  /** Баруун талын таб, товч */
  actions?: ReactNode;
  children: ReactNode;
  className?: string;
  /**
   * Дашбоардын том блок (dark glass): гарчиг 20/700, дотор зай 24px.
   * Бусад хуудас авсаархан хэвээр.
   */
  feature?: boolean;
  /** Гарчгийн хажуугийн жижиг чип — «148 захиалга» */
  badge?: string;
}) {
  return (
    <section
      className={`surface flex flex-col rounded-card px-4 py-4 transition-colors ${
        feature ? 'gap-5 sm:px-6 sm:py-6' : 'gap-3.5 sm:px-card'
      } ${className}`}
    >
      <div className="flex flex-wrap items-center gap-x-3.5 gap-y-1.5">
        <h2 className={feature ? 'text-title' : 'text-h2'}>{title}</h2>
        {badge ? (
          <span className="num rounded-[10px] bg-neutral-bg px-2.5 py-1 text-meta text-ink-2">{badge}</span>
        ) : null}
        {subtitle ? <span className="text-meta text-ink-2">{subtitle}</span> : null}
        {note ? <span className="text-label text-ink-3">{note}</span> : null}
        {actions ? <div className="ml-auto">{actions}</div> : null}
      </div>
      {children}
    </section>
  );
}

/** Section доторх хуваалт — дээр нь нимгэн зураас. */
export function SectionSplit({ label, children }: { label?: string; children: ReactNode }) {
  return (
    <div className="flex flex-col gap-2.5 border-t border-hair pt-3.5">
      {label ? <span className="text-meta text-ink-2">{label}</span> : null}
      {children}
    </div>
  );
}
